import { type AccountData, isEmpty, type UserProfileData, type Workflow } from '@terros/common'
import { getOwnershipWindows } from './ownershipWindows'

type GetHistoryCutoffDateProps = {
  workflow: Workflow
  account: Pick<AccountData, 'ownerHistory'>
  user: Pick<UserProfileData, 'userId' | 'permissionMap' | 'roles'>
}

/** For roles the workflow hides previous activity from: when the viewer's current ownership began */
export const getHistoryCutoffDate = ({ workflow, account, user }: GetHistoryCutoffDateProps): number | undefined => {
  if (isEmpty(account.ownerHistory)) return
  if (workflow.canSeeHistory(user)) return
  const windows = getOwnershipWindows({ ownerHistory: account.ownerHistory, userId: user.userId })
  // Only a stretch that's still going: someone who no longer owns the account gets no cutoff
  return windows.find(({ end }) => end === Infinity)?.start
}
